import PropTypes from 'prop-types';
import Bubble from './bubble';

const BubbleButton = ({ keyword }) => {
  return <Bubble>{keyword}</Bubble>;
};

BubbleButton.propTypes = {
  keyword: PropTypes.string.isRequired,
};

export default BubbleButton;
